import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { PARTNER360_NAMESPACE } from '../common/constants'

import { IProgramType } from './models/programType'

export const PARTNER360_CONFIGURATION_NAMESPACE = `${PARTNER360_NAMESPACE}/configuration`

// Async thunk constants
export const CHANGE_PROGRAM_TYPE = `${PARTNER360_CONFIGURATION_NAMESPACE}/changeProgramType`
export const CHANGE_FINANCIAL_YEAR = `${PARTNER360_CONFIGURATION_NAMESPACE}/changeFinancialYear`
export const REQUEST_PARTNER_DATA = `${PARTNER360_CONFIGURATION_NAMESPACE}/requestPartnerData`
export const REQUEST_PROGRAM_TYPES = `${PARTNER360_CONFIGURATION_NAMESPACE}/requestProgramTypes`

export const summaryProgramType: IProgramType = {
  programType: ProgramTypes.Summary,
  enabled: true,
  isDeprecated: false,
  translationKey: 'jbp-partner-type-summary',
  translation: 'Summary',
  orderBy: 0,
  links: [],
}
